import api from './api';

/**
 * Start a new conversation session
 * @param {Object} params - { sessionType, rawInput?, jobDescription?, interviewMode? }
 */
export const startConversation = async (params) => {
  const response = await api.post('/conversation/start', params);
  return response.data;
};

/**
 * Get user's active conversation (if any)
 */
export const getActiveConversation = async () => {
  const response = await api.get('/conversation/active');
  return response.data;
};

/**
 * Get a specific conversation session
 * @param {string} sessionId
 */
export const getConversation = async (sessionId) => {
  const response = await api.get(`/conversation/${sessionId}`);
  return response.data;
};

/**
 * Send a message in an active conversation
 * @param {string} sessionId
 * @param {string} message
 */
export const sendMessage = async (sessionId, message) => {
  const response = await api.post(`/conversation/${sessionId}/message`, { message });
  return response.data;
};

/**
 * Make a correction to extracted content
 * @param {string} sessionId
 * @param {string} field - Path to field (e.g., 'experience.0.bullets.1')
 * @param {any} correctedValue
 */
export const makeCorrection = async (sessionId, field, correctedValue) => {
  const response = await api.post(`/conversation/${sessionId}/correct`, {
    field,
    correctedValue
  });
  return response.data;
};

/**
 * Finalize conversation and create resume
 * @param {string} sessionId
 * @param {Object} params - { resumeName?, template? }
 */
export const finalizeConversation = async (sessionId, params = {}) => {
  const response = await api.post(`/conversation/${sessionId}/finalize`, params);
  return response.data;
};

/**
 * Abandon a conversation
 * @param {string} sessionId
 */
export const abandonConversation = async (sessionId) => {
  const response = await api.delete(`/conversation/${sessionId}`);
  return response.data;
};

/**
 * List user's conversations
 * @param {Object} params - { status?, limit? }
 */
export const listConversations = async (params = {}) => {
  const response = await api.get('/conversation', { params });
  return response.data;
};
